import Finance from '../models/finance';
import AnalyticsHelper from '../../utils/analytics-helper';
import StringUtils from '../../utils/string-utils';
import CurrencyFormatter from '../../utils/currency-formatter-lib';
import { getNumberWithDecimals } from '../../utils/number-utils';
import ScreenResolution from '../../utils/screen-resolution';
import Tooltip from '../../utils/tooltip';

export default class FinanceCompareModal {
    constructor(parent) {
        this.parent = parent;
        this.pricing = parent.pricing;
        this.finance = parent.finance;
        this.navigation = parent.navigation;
        this.financeCalculator = parent.financeCalculator;
        this.el = parent.el.querySelector('.configurator--finance-compare-modal');
        if (this.el) {
            this.finance = parent.finance;
            this.open = [...this.parent.el.querySelectorAll('.finance-compare-link')];
            this.loader = this.el.querySelector('.finance-compare-loader');
            this.close = this.el.querySelector('.modal-close');
            this.template = _.template(this.el.querySelector('#configurator--finance-compare-template').innerHTML.replaceAll('\\', '')),
            this.table = this.el.querySelector('.finance-compare-table');
            this.financeTypeEls = [...this.el.querySelectorAll('.finance-compare-type')];
            this.titleToggle = [...this.el.querySelectorAll('.finance-compare-title')];
            this.termsConditionLink = this.el.querySelector('.terms-and-conditions-link');
            this.financeTypes = this.initFinanceTypes();
            this.priceFormatter = new CurrencyFormatter({ decimals: HONDA.currency.roundToDecimalPlaceFinance ?? 0 });
            this.aprFormatter = (val) => `${val.toFixed(+HONDA.currency.roundToDecimalPlaceFinanceAPR || 1)}%`;
            this.eventListeners = [];
            this.setScreenSize();
            this.bind();
        }
    }

    bind() {
        this.close.addEventListener('click', (e) => this.hide());
        this.el.addEventListener('click', (e) => {
            if (!e.target.closest('.modal-container')) {
                this.hide();
            }
        });
        this.open.forEach((o) => o.addEventListener('click', (e) => {
            e.preventDefault();
            AnalyticsHelper.push(o);
            this.show();
        }));

        this.financeTypes.forEach((type) => {
            const { finance, calculator } = type;
            this.financeCalculator.bindInputs(finance, calculator);
            calculator.button.addEventListener('click', (e) => this.selectFinance(finance));
        });

        window.addEventListener('resize', () => {
            this.setScreenSize();
            this.financeAccordion();
        });

        this.financeAccordion();

        this.termsConditionLink?.addEventListener('click', (e) => {
            e.preventDefault();
            this.hide();
            this.navigation.scrollToSection('#terms');
        });
    }

    update() {
        if (this.finance.params?.products?.length > 1) {
            this.open?.forEach((el) => {
                el.classList.remove('hide');
            });
        }
    }

    initFinanceTypes() {
        return this.financeTypeEls.map((typeEl) => {
            const type = typeEl.dataset.id;
            const finance = new Finance(this.parent);
            finance.type = type;
            const calculator = { container: typeEl };
            calculator.calculateFinance = _.debounce(() => this.calculateFinance(finance), 100);
            this.financeCalculator.initElements(calculator);
            calculator.button = this.el.querySelector(`.finance-compare-buttons [data-id="${finance.type}"]`);
            return { finance, calculator };
        });
    }

    async calculateFinance(finance) {
        this.showLoader();
        await finance.getFinance();
        this.render();
        this.hideLoader();
    }

    render() {
        const financeSummaries = this.financeTypes.map((type) => type.finance.result);
        this.table.innerHTML = this.template({
            financeSummaries,
            pricing: this.pricing,
            stringReplace: StringUtils.replace,
            formatPrice: (val) => this.priceFormatter.to(val),
            getPercentage: ({ number, numberOfDecimals }) => `${getNumberWithDecimals({ number, numberOfDecimals })}%`,
            formatAPR: (val) => this.aprFormatter(val),
        });

        Tooltip.init();
    }

    show() {
        this.showLoader();
        this.el.showModal();
        this.el.querySelector('.modal-close').focus({ preventScroll: true });
        this.updateCalculators();
        this.hideLoader();
    }

    updateCalculators() {
        this.financeTypes.forEach(async (type) => {
            const { finance, calculator } = type;
            await finance.getFinanceParams();
            finance.getCurrentParams();
            this.financeCalculator.updateInputs(finance, calculator);
        });
    }

    selectFinance(finance) {
        this.finance.update(finance);
        this.financeCalculator.setType(finance.type);
        this.hide();
        this.navigation.scrollToSection('#configurator--finance-calculator');
    }

    hide() {
        this.el.close();
    }

    showLoader() {
        this.loader.classList.remove('hide');
    }

    hideLoader() {
        this.loader.classList.add('hide');
    }

    setScreenSize() {
        this.isTabletView = ScreenResolution.isTabletL();
    }

    financeAccordion() {
        if (this.isTabletView) {
            if (this.eventListeners.length === 0) {
                this.titleToggle.forEach((el) => {
                    const clickHandler = (e) => {
                        e.target.closest('.finance-compare-title').classList.toggle('active');
                    };
                    el.addEventListener('click', clickHandler);
                    this.eventListeners.push({ el, clickHandler });
                });
            }
        } else {
            this.removeEventListeners();
        }
    }

    removeEventListeners() {
        this.titleToggle.forEach((el) => {
            el.closest('.finance-compare-title').classList.remove('active');
        });
        this.eventListeners.forEach(({ el, clickHandler }) => {
            el.removeEventListener('click', clickHandler);
        });
        this.eventListeners = [];
    }
}
